import {
  INFORMATION_DETAIL_FETCH,
  INFORMATION_DETAIL_SUCCESS,
  INFORMATION_DETAIL_FAILURE
} from './actionTypes';

const initialState = {
  isLoaded: false,
  error: []
};

export const informationDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case INFORMATION_DETAIL_FETCH:
      return { ...state, isLoaded: false };
    case INFORMATION_DETAIL_SUCCESS:
      return { ...state, isLoaded: true };
    case INFORMATION_DETAIL_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/InformationDetail/reducer.js